export default __webpack_public_path__ + "linuxf51c9f.png";